import { homeRoutes } from "./common/home";
import { pwaRoutes } from "./common/pwa/route";
import type { IExtendedRouteObject } from "./types";

import { facultyRoutes } from "@routes/admin/facultyManagement/faculty/route";
import { academicGroupRoutes } from "@routes/admin/facultyManagement/academicGroup/route";
import { facultyAcademicGroupsRoutes } from "@routes/admin/facultyManagement/facultyAcademicGroups/route";
import { researchProposalRoutes } from "@routes/facultyMember/research";
import { achievementRoutes } from "@routes/facultyMember/achievement";
import { mediaRoutes } from "@routes/facultyMember/media";
import { studentRoutes } from "@routes/facultyMember/student";
import { laboratoriesRoutes } from "@routes/facultyMember/laboratory/route";
import { membersOfFacultyRoutes } from "@routes/admin/facultyManagement/membersOfFaculty/route";
import { academicGroupMembersRoutes } from "@routes/admin/facultyManagement/academicGroupMembers/route";
import { facultyAcademicGroupMembersRoutes } from "@routes/admin/facultyManagement/facultyAcademicGroupMembers/route";
import { crawlerRoutes } from "@routes/admin/crawler";
import { coursesRoutes } from "@routes/facultyMember/courseManagement/courses";
import { courseChaptersRoutes } from "@routes/facultyMember/courseManagement/courseChapter";
import { courseChapterExamsRoutes } from "@routes/facultyMember/courseManagement/courseChapterExam";
import { courseChapterProjectsRoutes } from "@routes/facultyMember/courseManagement/courseChapterProjects";
import { courseChapterExercisesRoutes } from "@routes/facultyMember/courseManagement/courseChapterExercise";
import { courseChapterSlidesRoutes } from "@routes/facultyMember/courseManagement/courseChapterSlides";
import { facultyMembersRoutes } from "@routes/admin/usersManagement/facultyMembers/route";
import { usersRoutes } from "@routes/admin/usersManagement/users/route";
import { staffsRoutes } from "@routes/admin/usersManagement/staff/route";
import { editProfileRoutes } from "@routes/common/editProfile";
import { changePasswordRoutes } from "@routes/common/changePassword";
import { notificationsSettingRoutes } from "@routes/common/notificationsSetting";
import { journalPapersRoutes } from "@routes/facultyMember/articlesAndBook/journalPaper/route";
import { conferencePapersRoutes } from "@routes/facultyMember/articlesAndBook/conferencePaper/route";
import { bookRoutes } from "@routes/facultyMember/articlesAndBook/book/route";

export const routes: IExtendedRouteObject[] = [
  ...pwaRoutes,
  ...homeRoutes,
  ...facultyRoutes,
  ...membersOfFacultyRoutes,
  ...academicGroupRoutes,
  ...facultyMembersRoutes,
  ...usersRoutes,
  ...staffsRoutes,
  ...crawlerRoutes,
  ...editProfileRoutes,
  ...changePasswordRoutes,
  ...notificationsSettingRoutes,
  ...academicGroupMembersRoutes,
  ...journalPapersRoutes,
  ...conferencePapersRoutes,
  ...researchProposalRoutes,
  ...bookRoutes,
  ...achievementRoutes,
  ...mediaRoutes,
  ...studentRoutes,
  ...laboratoriesRoutes,
  ...coursesRoutes,
  ...facultyAcademicGroupMembersRoutes,
  ...facultyAcademicGroupsRoutes,
  ...courseChaptersRoutes,
  ...courseChapterExamsRoutes,
  ...courseChapterExercisesRoutes,
  ...courseChapterProjectsRoutes,
  ...courseChapterSlidesRoutes,
];
